<script setup lang="ts">
import { Locale } from '~i18n/i18nConfig';

export type WhatsappLinkColor = 'green' | 'white';
// PROPS
defineProps({
    color: { type: String as PropType<WhatsappLinkColor>, default: 'white' },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const route = useRoute();
const config = useRuntimeConfig();
const { locale } = useTypedI18n();

// DATA
const phoneNumber = computed(() => {
    switch (locale.value) {
        case Locale.DE:
            return '+49 1522 4872022';

        default:
            return '+39 0287176063';
    }
});

const whatsappLink = computed(
    () =>
        `https://wa.me/${phoneNumber.value.replace(/[^+\d]/g, '')}?text=${encodeURIComponent(tt('whatsapp', { url: `${config.public.frontendBaseUrl}${route.fullPath}` }))}`
);
</script>

<template>
    <a :href="whatsappLink" target="_blank">
        <SvgoWhatsappGreen v-if="color === 'green'" class="h-[36px] w-[160px]" :font-controlled="false" filled />
        <SvgoWhatsapp v-else class="h-[36px] w-[160px]" :font-controlled="false" filled />
    </a>
</template>
